import { useTranslate } from "@tolgee/react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "#/components/ui/alert-dialog";

type CloseAllHeaderProps = {
	onConfirm: () => void;
	variant?: "close" | "cancel";
};

const VARIANT_KEYS = {
	close: {
		label: "positions.close-all",
		title: "positions.close-all-title",
		description: "positions.close-all-description",
		confirm: "positions.close-all-confirm",
	},
	cancel: {
		label: "orders.cancel-all",
		title: "orders.cancel-all-title",
		description: "orders.cancel-all-description",
		confirm: "orders.cancel-all-confirm",
	},
} as const;

export function CloseAllHeader({
	onConfirm,
	variant = "close",
}: CloseAllHeaderProps) {
	const { t } = useTranslate();
	const keys = VARIANT_KEYS[variant];
	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<button
					type="button"
					className="cursor-pointer text-primary hover:underline h-full flex items-center"
				>
					{t(keys.label)}
				</button>
			</AlertDialogTrigger>
			<AlertDialogContent size="sm">
				<AlertDialogHeader>
					<AlertDialogTitle>{t(keys.title)}</AlertDialogTitle>
					<AlertDialogDescription>{t(keys.description)}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel size="sm">{t("general.cancel")}</AlertDialogCancel>
					<AlertDialogAction
						size="sm"
						variant="destructive"
						onClick={() => void onConfirm()}
					>
						{t(keys.confirm)}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
